import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireJobVacanciesList } from "/web/src/js/roundhouse/misc/hr/job-vacancies-list.js";
var jobVacanciesListExports = requireJobVacanciesList();
export { jobVacanciesListExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(jobVacanciesListExports);